<mat-form-field class="w-full">
    <mat-label>Country</mat-label>
    <input type="text"
           placeholder="Country"
           matInput
           [formControl]="_form.controls.country"
           (input)="inputFilterCountries($event)"
           [matAutocomplete]="countryAutocomplete"
           #trigger1="matAutocompleteTrigger" appAutocompletePosition="trigger1"
    >
    <mat-autocomplete #countryAutocomplete="matAutocomplete" [displayWith]="displayCountry" (optionSelected)="selectCountry($event)">
        <mat-option *ngFor="let option of filteredCountries" [value]="option" >{{option.name}}</mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="ValidationHelperService.isInvalid(_form.controls.country)"> {{
            ValidationHelperService.getErrorMessage(_form.controls.country)
        }}</mat-error>
</mat-form-field>
<mat-form-field class="w-full">
    <mat-label>State / Province</mat-label>
    <input type="text"
           placeholder="State / province"
           matInput
           [formControl]="_form.controls.state"
           (input)="inputFilterStates($event)"
           [matAutocomplete]="stateAutocomplete"
           #trigger2="matAutocompleteTrigger" appAutocompletePosition="trigger2"
    >
    <mat-autocomplete #stateAutocomplete="matAutocomplete" [displayWith]="displayState" (optionSelected)="selectState($event)">
        <mat-option *ngFor="let option of filteredStates" [value]="option" >{{option.name}}</mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="ValidationHelperService.isInvalid(_form.controls.state)"> {{
            ValidationHelperService.getErrorMessage(_form.controls.state)
        }}</mat-error>
</mat-form-field>
<mat-form-field class="w-full">
    <mat-label>City</mat-label>
    <input type="text"
           placeholder="City"
           matInput
           [formControl]="_form.controls.city"
           (input)="inputFilterCities($event)"
           [matAutocomplete]="cityAutocomplete"
           #trigger3="matAutocompleteTrigger" appAutocompletePosition="trigger3"
    >
    <mat-autocomplete #cityAutocomplete="matAutocomplete" [displayWith]="displayCity">
        <mat-option *ngFor="let option of filteredCities" [value]="option" >{{option.name}}</mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="ValidationHelperService.isInvalid(_form.controls.city)"> {{
            ValidationHelperService.getErrorMessage(_form.controls.city)
        }}</mat-error>
</mat-form-field>
<mat-form-field class="w-full">
    <mat-label>Address line 1</mat-label>
    <input matInput type="text" [formControl]="_form.controls.addressLine1">
    <mat-error *ngIf="ValidationHelperService.isInvalid(_form.controls.addressLine1)">
        {{ValidationHelperService.getErrorMessage(_form.controls.addressLine1)}}
    </mat-error>
</mat-form-field>
<mat-form-field class="w-full">
    <mat-label>Address line 2</mat-label>
    <input matInput type="text" [formControl]="_form.controls.addressLine2">
    <mat-error *ngIf="ValidationHelperService.isInvalid(_form.controls.addressLine2)">
        {{ValidationHelperService.getErrorMessage(_form.controls.addressLine2)}}
    </mat-error>
</mat-form-field>
<mat-form-field class="w-full">
    <mat-label>Zip code</mat-label>
    <input matInput type="text" [formControl]="_form.controls.zipCode">
    <mat-error *ngIf="ValidationHelperService.isInvalid(_form.controls.zipCode)">
        {{ValidationHelperService.getErrorMessage(_form.controls.zipCode)}}
    </mat-error>
</mat-form-field>
